import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

export function useOfflineStatus() {
  const isOffline = ref(typeof navigator !== 'undefined' ? navigator.onLine === false : false)
  const connection = ref(null)

  const update = () => {
    isOffline.value = typeof navigator !== 'undefined' ? navigator.onLine === false : false
    connection.value = typeof navigator !== 'undefined'
      ? (navigator.connection || navigator.mozConnection || navigator.webkitConnection || null)
      : null
  }

  const connectionType = computed(() => {
    // Not always available; Chrome exposes `effectiveType` more commonly than `type`.
    return connection.value?.type || null
  })

  const effectiveType = computed(() => {
    // 'slow-2g' | '2g' | '3g' | '4g' (best-effort hint)
    return connection.value?.effectiveType || null
  })

  const isWifi = computed(() => connectionType.value === 'wifi')
  const isCellular = computed(() => connectionType.value === 'cellular')

  onMounted(() => {
    update()
    window.addEventListener('online', update)
    window.addEventListener('offline', update)
    if (connection.value?.addEventListener) {
      connection.value.addEventListener('change', update)
    }
  })

  onBeforeUnmount(() => {
    window.removeEventListener('online', update)
    window.removeEventListener('offline', update)
    if (connection.value?.removeEventListener) {
      connection.value.removeEventListener('change', update)
    }
  })

  return {
    isOffline,
    connectionType,
    effectiveType,
    isWifi,
    isCellular,
    update
  }
}

